import GetCompaniesRequestModelBase from '../_generated/modelBases/get-companies-request-model-base';

export default class GetCompaniesRequestModel extends GetCompaniesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
